import get from "lodash/get";

import { translate } from "app/filters/i18nFilter";
import { prepareRequestKWTrendData } from "app/pages/activation/components/RankWidget/helpers/prepareRequestKWTrendData";
import { widgetTexts } from "app/pages/activation/components/RankWidget/texts";
import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";
import useActivationObjectQuery from "app/pages/activation/queries/data/useActivationObjectQuery";
import { useGetIsEnoughCreditsToCreateRTQuery } from "app/pages/activation/queries/rankTracker/useGetIsEnoughCreditsToCreateRTQuery";
import { useGetKeywordsTrendsQuery } from "app/pages/activation/queries/rankTracker/useGetKeywordsTrendsQuery";
import { useGetRTCampaignQuery } from "app/pages/activation/queries/rankTracker/useGetRTCampaignQuery";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const useRTWidgetData = (isViewerMode: boolean) => {
    const { key: projectId } = proNavigator.getParams();

    const { data: project } = useActivationObjectQuery(projectId);

    const isRtApiEnabled = ActivationComponentAssets.isRankTrackerActivationApiEnabled;

    const RTCampaignId = get(project, "assets.rankTrackerCampaignId", "");
    const isTopicsExists = get(project, "assets.topics", []).length > 0;

    const { data: RTCampaignData, isLoading: isRTCampaignLoading } = useGetRTCampaignQuery(
        projectId,
        RTCampaignId,
        isRtApiEnabled,
    );
    const { data: KeywordsTrendData, isLoading: KeywordsTrendsIsLoading } = useGetKeywordsTrendsQuery(
        prepareRequestKWTrendData(RTCampaignData),
    );

    const isWidgetDisabled = !RTCampaignId;
    const isScraping = !isWidgetDisabled && !RTCampaignData?.firstScrapeTime && !isRTCampaignLoading;

    const isTooltipEnabled = !isTopicsExists || isViewerMode;

    const { data: isRTWidgetAllowed } = useGetIsEnoughCreditsToCreateRTQuery(projectId, isRtApiEnabled);

    const buttonText = !isTopicsExists
        ? translate(widgetTexts.createButtonText)
        : translate(widgetTexts.trackButtonText);

    const buttonTooltip = isViewerMode
        ? translate(widgetTexts.createButtonViewerTooltip)
        : translate(widgetTexts.createButtonTooltip);

    return {
        project,
        RTCampaignData,
        KeywordsTrendData,
        isRTCampaignLoading,
        KeywordsTrendsIsLoading,
        isWidgetDisabled,
        isScraping,
        isTopicsExists,
        isTooltipEnabled,
        buttonText,
        buttonTooltip,
        isWidgetAllowed: isRtApiEnabled && (Boolean(isRTWidgetAllowed) || !!RTCampaignId),
    };
};
